import service from '@/backend/modnpay_app_api'
import Vue from 'vue'
import { THROW_APP_ERROR, THROW_APP_LOGIN_OVER_LAP } from '@/router'
export default Vue.extend({
  data () {
    return {
      email: '', // 사용자 이메일 번호
      saveEmail: false,
      userName: '',
      showSingleBtnDialogFlag: false,
      singleBtnMsgType: 0,
      onClickConfirmBtn: undefined
    }
  },
  created () {
    if (this.isUser) {
      this.myInfo()
    } else {
      const userEmail = localStorage.getItem('userEmail')
      const saveEmail = localStorage.getItem('saveEmail')
      if (userEmail && userEmail !== 'null') {
        this.email = userEmail
        this.saveEmail = saveEmail
      }
    }
  },
  methods: {
    async myInfo () { // 사용자 정보 조회
      const req = {}
      const { data } = await service.myInfo(req)
      const code = data.resultCode
      if (code === 0) {
        this.userName = data.name
        this.phoneNo = data.phone
        this.saveEmail = !!data.receiptEmail
        if (data.receiptEmail) {
          this.email = data.receiptEmail
        }
      } else if (code === 15033) {
        THROW_APP_LOGIN_OVER_LAP()
      } else {
        THROW_APP_ERROR()
      }
    }
  }

})
